import { DOCUMENT } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY } from "rxjs";
import { catchError, tap } from "rxjs/operators";

import { AuthModel } from "@intocare/auth-data";

@Component({
	template: "",
})
export class LogOutComponent implements OnInit {
	private readonly router = inject(Router);
	private auth = inject(AuthModel);
	private document = inject<Document>(DOCUMENT);

	ngOnInit(): void {
		this.auth
			.logOut()
			.pipe(
				tap((redirectUrl) => {
					if (redirectUrl) {
						this.document.location.replace(redirectUrl);
					} else {
						this.router.navigate(["select-organisation"]).then(() => {
							this.document.location.reload();
						});
					}
				}),
				catchError(() => {
					this.router.navigate(["select-organisation"]).then(() => {
						this.document.location.reload();
					});
					return EMPTY;
				}),
			)
			.subscribe();
	}
}
